<template>
  <div>
    <div class="card-header">
      <div class="row w-100">
        <div class="col">
          <selectlist
            name="technician"
            label="Vehicle Technician"
            :value="filters.completed_by"
            @input="setCompletedBy"
            :options="technicians"
            key-name="id"
            label-name="full_name"
            :stacked="true"
          ></selectlist>
        </div>
      </div>
    </div>

    <table class="table mt-3">
      <thead>
        <tr>
          <th>Vehicle</th>
          <th>ABI Group</th>
          <th>Mileage</th>
          <th>Completed</th>
          <th>Completed By</th>
          <th></th>
        </tr>
      </thead>
      <tbody v-if="pdis?.length">
        <tr v-bind:key="index" v-for="(pdi, index) in pdis">
          <td>
            {{ pdi.vehicle?.registration }}
          </td>
          <td>
            {{ pdi.abiGroup?.name }}
          </td>
          <td>
            {{ pdi.mileage }}
          </td>
          <td>
            {{ pdi.completed_at | date }}
          </td>
          <td>
            {{ pdi.completedBy?.full_name }}
          </td>
          <td>
            <router-link
              class="btn btn-primary"
              :to="`/pdi-queue/${pdi.identifier}`"
            >
              View
            </router-link>
            <form-button
              level="primary"
              @clicked="download(pdi)"
              :indicator="downloading == pdi.id"
            >
              Download
            </form-button>
          </td>
        </tr>
      </tbody>
      <tbody v-if="!pdis.length">
        <tr>
          <td colspan="6" class="text-center">
            No results found
          </td>
        </tr>
      </tbody>
    </table>

    <div class="card-footer text-right" v-if="showPagination">
      <pagination
        :data="paginator_data"
        v-on:updateResults="getData"
      ></pagination>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    vehicle: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      pdis: [],
      paginator_data: null,
      filters: {
        completed_by: ''
      },
      downloading: undefined
    };
  },

  computed: {
    showPagination() {
      return (
        this.paginator_data?.next_page_url || this.paginator_data?.prev_page_url
      );
    },

    technicians() {
      return this.$store.getters['ClaimHandlers/technicians'];
    }
  },

  mounted() {
    this.$store.commit('ClaimHandlers/retrieve');

    this.getPdis();
  },

  methods: {
    getPdis() {
      this.getData(`/pdi?per_page=${this.perPage}`);
    },

    getData(url) {
      Object.keys(this.filters).forEach(key => {
        const filterValue = this.getFilterValue(key);

        // Check if the key is 'completed_by' and the value is a number greater than zero
        if (key === 'completed_by') {
          const completedByValue = parseInt(filterValue);
          if (!isNaN(completedByValue) && completedByValue > 0) {
            url = `${url}&filter[${key}]=${completedByValue}`;
          }
        } else if (filterValue !== null && filterValue !== undefined) {
          url = `${url}&filter[${key}]=${filterValue}`;
        }
      });

      window.Ajax.get(
        `${url}&parts=vehicle,abiGroup,completedBy&filter[vehicle_id]=${this.vehicle.id}`
      )
        .then(response => {
          this.pdis = response.data.data;
          this.paginator_data = response.data;
        })
        .catch(() => {
          window.toastify.error(
            'Error',
            'Sorry, an error occurred while loading the PDI history'
          );
        });
    },

    getFilterValue(key) {
      const value = this.filters[key];

      if (['from', 'to'].includes(key)) {
        if (value) {
          return window.DateManager.format(value, 'YYYY-MM-DD');
        }
      }

      return value;
    },

    download(pdi) {
      this.downloading = pdi.id;

      window.Ajax.download(`/pdi/${pdi.identifier}/download`)
        .then(() => (this.downloading = undefined))
        .catch(() => {
          this.downloading = undefined;

          window.toastify.error(
            'Oops',
            'An error occurred while downloading the PDF'
          );
        });
    },

    setCompletedBy(id) {
      this.filters.completed_by = id;

      this.getPdis();
    }
  }
};
</script>
